import React from 'react';
import { motion } from 'framer-motion';

const lineReveal = {
  hidden: { y: '110%' },
  visible: (i) => ({
    y: '0%',
    transition: { duration: 0.9, delay: 0.25 + i * 0.12, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const HomeHero = () => {
  return (
    <section id="hero" data-testid="home-hero" className="relative bg-black pt-28 sm:pt-32 pb-10 overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[90vw] max-w-[800px] h-[300px] sm:h-[400px] bg-white/5 rounded-full blur-[120px] sm:blur-[140px] pointer-events-none" />

      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1 }}
          data-testid="hero-eyebrow"
          className="text-gray-400 font-bold text-xs sm:text-sm tracking-[0.35em] uppercase mb-5"
        >
          The Dillon Blueprint
        </motion.p>

        <h1 data-testid="hero-headline" aria-label="Choose Your Blueprint" className="font-display text-white text-4xl sm:text-6xl lg:text-7xl leading-[0.95] uppercase">
          <span className="block overflow-hidden pb-2">
            <motion.span custom={0} variants={lineReveal} initial="hidden" animate="visible" className="block">
              Choose Your <span className="bg-gradient-to-b from-white via-white to-neutral-400 bg-clip-text text-transparent">Blueprint</span>
            </motion.span>
          </span>
        </h1>

        <motion.div
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 0.8, delay: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="w-24 h-1 bg-gray-400 mx-auto mt-5 origin-left"
        />

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.95 }}
          data-testid="hero-subheadline"
          className="text-gray-300 text-base md:text-lg mt-5 max-w-xl mx-auto leading-relaxed"
        >
          Two paths. One goal: becoming the strongest version of yourself.
        </motion.p>
      </div>
    </section>
  );
};
